function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // @flow

/*::
export type Slice = {
  value: string,
  match: boolean,
}
*/


export var breakdownString = function breakdownString(str
/*: string */
, breakStr
/*: string */
, caseSensitive
/*: boolean */
)
/*: Array<Slice> */
{
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }

  if (!str || !breakStr) {
    return [{
      value: str,
      match: false
    }];
  }

  var breakdown = [];
  var regex = new RegExp(breakStr.replace(/[-[\]{}()*+?.,\\^$|#/]/g, '\\$&'), "g" + (caseSensitive ? '' : 'i'));
  var matches = str.matchAll(regex);
  var lastPos = 0; // eslint-disable-next-line no-restricted-syntax

  for (var _iterator = _createForOfIteratorHelperLoose(matches), _step; !(_step = _iterator()).done;) {
    var match = _step.value;

    if (match.index > lastPos) {
      breakdown.push({
        value: str.substring(lastPos, match.index),
        match: false
      });
    }

    breakdown.push({
      value: match[0],
      match: true
    });
    lastPos = match.index + match[0].length;
  }

  if (lastPos < str.length) {
    breakdown.push({
      value: str.substring(lastPos),
      match: false
    });
  }

  return breakdown;
};